import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const ArchiveIllustration = ({ width = 37, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 35">
      <g fill="none" fillRule="evenodd">
        <path fill="#FFE6AB" d="M6.937 11.875L0 18.811 0 18.812 37 18.812 30.062 11.875z" />
        <path
          fill="#FF7236"
          d="M8.093 14.187h20.812l5.782 5.781s-.462 5.782-1.272 5.782H3.353c-.694 0-1.04-5.782-1.04-5.782l5.78-5.781z"
        />
        <path fill="#DADADA" d="M9.881 17.468L27.12 17.468 27.12 -0.001 9.881 -0.001z" />
        <path fill="#F6F6F6" d="M7.55 23.43L29.451 23.43 29.451 2.796 7.55 2.796z" />
        <path
          fill="#FDBE10"
          d="M25.437 19.311v2.33c0 .988-.808 1.796-1.795 1.796H13.358c-.987 0-1.796-.809-1.796-1.796v-2.33c0-.276-.224-.5-.499-.5H0v14.394c0 .986.808 1.794 1.795 1.794h33.41c.987 0 1.795-.808 1.795-1.794V18.812H25.937c-.276 0-.5.223-.5.5"
        />
        <path
          fill="#92A2A4"
          d="M24.686 11.147H12.314c-.562 0-1.016-.455-1.016-1.016 0-.561.454-1.016 1.016-1.016h12.372c.562 0 1.016.455 1.016 1.016 0 .561-.454 1.016-1.016 1.016M24.686 15.488H12.314c-.562 0-1.016-.455-1.016-1.016 0-.561.454-1.016 1.016-1.016h12.372c.562 0 1.016.455 1.016 1.016 0 .56-.454 1.016-1.016 1.016"
        />
        <path
          fill="#000"
          d="M18.569 35h16.599c.988 0 1.796-.809 1.796-1.795V18.813l-6.938-6.938h-.611v-9.08h-2.332V-.001h-8.514v35z"
          opacity=".1"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
